import { requireAnySystemPermission, requireOrgPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { getActiveOrganizations } from '../mission/utils/getActiveOrganizations';
export function authorizeManageMissionByMissionId(context, userState, missionId) {
    if (requireAnySystemPermission(userState, 'manage-missions')) {
        return true;
    }
    if (!requireAnySystemPermission(userState, 'manage-all-admin-missions')) {
        return false;
    }
    const missionStorage = context.storage('missions');
    const mission = missionStorage.get(missionId);
    return authorizeManageMissionByAccessSharing({
        userState,
        missionTypeId: mission.data.typeId,
        missionAccessSharing: mission.data.accessSharing,
    });
}
export const authorizeMissionAccessSharingForLowerLevelAdmin = (userState, missionAccessSharing, missionTypeId) => {
    const missionIsPublic = (missionAccessSharing === null || missionAccessSharing === void 0 ? void 0 : missionAccessSharing.type) === 'public';
    if (missionIsPublic) {
        return false;
    }
    const userCanSeeSomeMissionsByType = userState.authorizedMissionTypeIds.length > 0 && missionTypeId && userState.authorizedMissionTypeIds.includes(missionTypeId);
    if (!userCanSeeSomeMissionsByType) {
        return false;
    }
    if ((missionAccessSharing === null || missionAccessSharing === void 0 ? void 0 : missionAccessSharing.type) === 'organizations') {
        return authorizeMissionOrganizationsSharing(userState, missionAccessSharing.organizations);
    }
    if ((missionAccessSharing === null || missionAccessSharing === void 0 ? void 0 : missionAccessSharing.type) === 'groups') {
        return authorizeMissionGroupsSharing(userState, missionAccessSharing.groups);
    }
    return false;
};
export const authorizeMissionOrganizationsSharing = (userState, organizationSharing) => {
    const activeOrganizationIds = getActiveOrganizations(userState);
    return organizationSharing.some((id) => activeOrganizationIds.includes(id) && requireOrgPermission(userState, id, 'manage-organization', 'manage-members'));
};
export const authorizeMissionGroupsSharing = (userState, groupSharing) => {
    return groupSharing.some((groupId) => userState.managedGroupIds.includes(groupId));
};
export function authorizeManageMissionByAccessSharing({ userState, missionTypeId, missionAccessSharing, }) {
    return (requireAnySystemPermission(userState, 'manage-missions') ||
        (requireAnySystemPermission(userState, 'manage-all-admin-missions') &&
            authorizeMissionAccessSharingForLowerLevelAdmin(userState, missionAccessSharing, missionTypeId)));
}
export function authorizeManageMissionClassifiers(userState) {
    return requireAnySystemPermission(userState, 'manage-all-classifiers', 'manage-mission-classifiers');
}
